/**
 * @generated SignedSource<<0708289ff943051e5c51366b3e3a2518>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useClaudeMarketplace_query$data = {
  readonly UrlConfig: {
    readonly claudeMarketplace: {
      readonly mcpServer: string;
      readonly name: string;
      readonly plugin: string;
      readonly url: string;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useClaudeMarketplace_query";
};
export type useClaudeMarketplace_query$key = {
  readonly " $data"?: useClaudeMarketplace_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useClaudeMarketplace_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useClaudeMarketplace_query",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UrlConfig",
          "kind": "LinkedField",
          "name": "UrlConfig",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ClaudeMarketplace",
              "kind": "LinkedField",
              "name": "claudeMarketplace",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mcpServer",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "plugin",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "cfd9e0bf6be8bd9b3ccefdda3f268972";

export default node;
